/*
 * Yafeapedia
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.1
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.64
 *
 * Do not edit the class manually.
 *
 */
import ApiClient from '../ApiClient';
import AuthorEntity from './AuthorEntity';
import CategoryEntity from './CategoryEntity';
import MediaEntity from './MediaEntity';

/**
 * The AlbumEntity model module.
 * @module model/AlbumEntity
 * @version 1.0.1
 */
export default class AlbumEntity {
  /**
   * Constructs a new <code>AlbumEntity</code>.
   * @alias module:model/AlbumEntity
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>AlbumEntity</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/AlbumEntity} obj Optional instance to populate.
   * @return {module:model/AlbumEntity} The populated <code>AlbumEntity</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new AlbumEntity();
      if (data.hasOwnProperty('id'))
        obj.id = ApiClient.convertToType(data['id'], 'String');
      if (data.hasOwnProperty('contentEntities'))
        obj.contentEntities = ApiClient.convertToType(data['contentEntities'], [MediaEntity]);
      if (data.hasOwnProperty('category'))
        obj.category = CategoryEntity.constructFromObject(data['category']);
      if (data.hasOwnProperty('title'))
        obj.title = ApiClient.convertToType(data['title'], 'String');
      if (data.hasOwnProperty('description'))
        obj.description = ApiClient.convertToType(data['description'], 'String');
      if (data.hasOwnProperty('coverImg'))
        obj.coverImg = ApiClient.convertToType(data['coverImg'], 'String');
      if (data.hasOwnProperty('lang'))
        obj.lang = ApiClient.convertToType(data['lang'], 'Number');
      if (data.hasOwnProperty('addedAt'))
        obj.addedAt = ApiClient.convertToType(data['addedAt'], 'Date');
      if (data.hasOwnProperty('mediaType'))
        obj.mediaType = ApiClient.convertToType(data['mediaType'], 'Number');
      if (data.hasOwnProperty('lastEdit'))
        obj.lastEdit = ApiClient.convertToType(data['lastEdit'], 'Date');
      if (data.hasOwnProperty('author'))
        obj.author = AuthorEntity.constructFromObject(data['author']);
      if (data.hasOwnProperty('lastEditBy'))
        obj.lastEditBy = AuthorEntity.constructFromObject(data['lastEditBy']);
      if (data.hasOwnProperty('deletedAt'))
        obj.deletedAt = ApiClient.convertToType(data['deletedAt'], 'Date');
      if (data.hasOwnProperty('published'))
        obj.published = ApiClient.convertToType(data['published'], 'Boolean');
    }
    return obj;
  }
}

/**
 * @member {String} id
 */
AlbumEntity.prototype.id = undefined;

/**
 * @member {Array.<module:model/MediaEntity>} contentEntities
 */
AlbumEntity.prototype.contentEntities = undefined;

/**
 * @member {module:model/CategoryEntity} category
 */
AlbumEntity.prototype.category = undefined;

/**
 * @member {String} title
 */
AlbumEntity.prototype.title = undefined;

/**
 * @member {String} description
 */
AlbumEntity.prototype.description = undefined;

/**
 * @member {String} coverImg
 */
AlbumEntity.prototype.coverImg = undefined;

/**
 * @member {Number} lang
 */
AlbumEntity.prototype.lang = undefined;

/**
 * @member {Date} addedAt
 */
AlbumEntity.prototype.addedAt = undefined;

/**
 * @member {Number} mediaType
 */
AlbumEntity.prototype.mediaType = undefined;

/**
 * @member {Date} lastEdit
 */
AlbumEntity.prototype.lastEdit = undefined;

/**
 * @member {module:model/AuthorEntity} author
 */
AlbumEntity.prototype.author = undefined;

/**
 * @member {module:model/AuthorEntity} lastEditBy
 */
AlbumEntity.prototype.lastEditBy = undefined;

/**
 * @member {Date} deletedAt
 */
AlbumEntity.prototype.deletedAt = undefined;

/**
 * @member {Boolean} published
 */
AlbumEntity.prototype.published = undefined;

